/*
 * Copyright (c) 2024 SARL SIGMA POLYNESIA
 */

import { useIntl } from 'react-intl'
import {
  LEASE_STATUS_ENDED,
  LEASE_STATUS_NOTICE,
  LEASE_STATUS_ONGOING,
  LEASE_STATUS_TO_COME_UP
} from '../../enums/LeaseStatusCodes.mjs'
import Filter, { FilterableProps } from '../Filter'
import useArrayFilter from '../../../../client/js/hooks/useArrayFilter'
import { Checkbox, Radio } from '@mantine/core'

function LeaseStatusFilter (props: FilterableProps<string[]>) {
  const { onChange, value } = props
  const intl = useIntl()
  const [array, handleChange] = useArrayFilter(value, onChange)
  return (
    <Filter>
      <Radio
        checked={array.length === 0}
        id="lease_status_all_filter"
        label={intl.formatMessage({
          id: 'all',
          defaultMessage: 'Tout'
        })}
        name="status"
        onChange={(event) => {
          if (event.target.checked) {
            onChange(event.target.name, undefined)
          }
        }}
        value=""
      />
      <Checkbox
        checked={array.includes(LEASE_STATUS_TO_COME_UP)}
        id="lease_status_to_come_up_filter"
        label={intl.formatMessage({
          id: 'to_come_up',
          defaultMessage: 'À venir'
        })}
        name="status"
        onChange={handleChange}
        value={LEASE_STATUS_TO_COME_UP}
      />
      <Checkbox
        checked={array.includes(LEASE_STATUS_ONGOING)}
        id="lease_status_ongoing_filter"
        label={intl.formatMessage({
          id: 'ongoing',
          defaultMessage: 'En cours'
        })}
        name="status"
        onChange={handleChange}
        value={LEASE_STATUS_ONGOING}
      />
      <Checkbox
        checked={array.includes(LEASE_STATUS_NOTICE)}
        id="lease_status_notice_filter"
        label={intl.formatMessage({
          id: 'notice',
          defaultMessage: 'Préavis'
        })}
        name="status"
        onChange={handleChange}
        value={LEASE_STATUS_NOTICE}
      />
      <Checkbox
        checked={array.includes(LEASE_STATUS_ENDED)}
        id="lease_status_ended_filter"
        label={intl.formatMessage({
          id: 'finished',
          defaultMessage: 'Terminé'
        })}
        name="status"
        onChange={handleChange}
        value={LEASE_STATUS_ENDED}
      />
    </Filter>
  )
}

export default LeaseStatusFilter
